import React from 'react';
import Hero from './Hero';
import Features from './Features';
import LearnDIY from './LearnDIY';
import PreLaunchSurvey from './PreLaunchSurvey';
import HowItWorks from './HowItWorks';

const Home: React.FC = () => {
  return (
    <div className="home">
      <Hero />
      <Features />
      <LearnDIY />
      <PreLaunchSurvey />
      <HowItWorks />
    </div>
  );
};

export default Home;
